import { AppConsts } from '@shared/AppConsts';
import { Component, Injector, ViewEncapsulation, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import {
    Status,
    PaymentStatus,
    TaxType,
    SalesType,
    EntityDto,
    SalesNotesServiceProxy,
    SalesNotesType,
    SalesNotesDto,
    SalesType2,
    SalesNotesEditDto,
} from '@shared/service-proxies/service-proxies';
import { NotifyService } from 'abp-ng2-module';
import { AppComponentBase } from '@shared/common/app-component-base';
import { TokenAuthServiceProxy } from '@shared/service-proxies/service-proxies';
import { UtilsService } from 'app/shared/common/utils/utils-service';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Table, TableModule } from 'primeng/table';
import { Paginator, PaginatorModule } from 'primeng/paginator';
import { LazyLoadEvent, PrimeTemplate } from 'primeng/api';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { filter as _filter } from 'lodash-es';
import { DateTime } from 'luxon';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

import { HttpClient } from '@angular/common/http';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { finalize } from 'rxjs';

import { ExcelColumnSelectionModalComponent } from '@app/shared/common/excel-column-selection/excel-column-selection-modal';

@Component({
    templateUrl: './salesnotes.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
    standalone: false,
})
export class SalesNotesComponent extends AppComponentBase {
    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;

    @ViewChild('ExcelFileUpload', { static: false }) excelFileUpload: FileUpload;

    @ViewChild('excelColumnSelectionModal', { static: true })
    excelColumnSelectionModal: ExcelColumnSelectionModalComponent;

    advancedFiltersAreShown = false;
    transactionNo = '';
    referenceNo = '';
    customerId: number;
    locationId: number;
    currencyNameFilter = '';
    paymentTermNameFilter = '';
    filterText: '';
    status = Status;
    paymentStatus = PaymentStatus;
    taxType = TaxType;
    salesType = SalesType2;
    headerText : string;
    description : string;
    type: number;

    constructor(
        injector: Injector,
        private _salesNotesServiceProxy: SalesNotesServiceProxy,
        private _notifyService: NotifyService,
        private _tokenAuth: TokenAuthServiceProxy,
        private _activatedRoute: ActivatedRoute,
        private _fileDownloadService: FileDownloadService,
        private _router: Router,
        private _dateTimeService: DateTimeService,
        private _httpClient: HttpClient,
        public utilsService: UtilsService
    ) {
        super(injector);
    }

    getSalesNotes(event?: LazyLoadEvent) {
        this.type = this._activatedRoute.snapshot.params['type'];
        var salesNotesType;
        if (this.type == 1) {
            this.headerText = this.l('CreateInvoice');
            this.description = this.l('CreateInvoiceHeaderInfo');
            salesNotesType = SalesNotesType.SalesDebit;
        } else if (this.type == 2) {
            this.headerText = this.l('CreateCreditNotes');
            this.description = this.l('CreateCreditNotesHeaderInfo');
            salesNotesType = SalesNotesType.SalesCredit;
        }
        else if (this.type == 3) {
            this.headerText = this.l('CreateReceiptFromOthers');
            this.description = this.l('CreateReceiptFromOthersHeaderInfo');
            salesNotesType = SalesNotesType.ReceiptFromOthers;
        }

        
        if (this.primengTableHelper.shouldResetPaging(event)) {
            this.paginator.changePage(0);
            if (this.primengTableHelper.records && this.primengTableHelper.records.length > 0) {
                return;
            }
        }

        this.primengTableHelper.showLoadingIndicator();
       
        this._salesNotesServiceProxy
            .getAll(
                this.filterText,
                null,
                null,
                this.locationId,
                this.customerId,
                salesNotesType,
                this.transactionNo,
                this.referenceNo,
                this.primengTableHelper.getSorting(this.dataTable),
                this.primengTableHelper.getSkipCount(this.paginator, event),
                this.primengTableHelper.getMaxResultCount(this.paginator, event))
            .subscribe((result) => {
                this.primengTableHelper.totalRecordsCount = result.totalCount;
                this.primengTableHelper.records = result.items;
                this.primengTableHelper.hideLoadingIndicator();
            });
    }
    print(id: number): void {
            window.open(AppConsts.remoteServiceBaseUrl + '/SalesNotes/SalesNotes/' + id, '_blank');
        }

    reloadPage(): void {
        this.paginator.changePage(this.paginator.getPage());
    }



    deleteSalesNotes(salesNotes: SalesNotesDto): void {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                this._salesNotesServiceProxy.delete(salesNotes.id).subscribe(() => {
                    this.reloadPage();
                    this.notify.success(this.l('SuccessfullyDeleted'));
                });
            }
        });
    }
    convertToDraft(salesNotes: SalesNotesEditDto): void {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                this.primengTableHelper.showLoadingIndicator();
                var entitDto = new EntityDto();
                entitDto.id = salesNotes.id;
                this._salesNotesServiceProxy.convertSalesNotesToDraft(entitDto).subscribe(() => {
                    this.getSalesNotes({});
                    this.notify.success(this.l('SuccessfullyDraft'));
                    this.primengTableHelper.hideLoadingIndicator();
                });
            }
        });

      
    }

    

    createSalesNotes(): void {
        this._router.navigate(['/app/account/salesNotes/createOrEdit'], { queryParams: { type: this.type } });
    }

    convertToInvoice(salesNotes: SalesNotesEditDto): void {

        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                var entitDto = new EntityDto();
                this.primengTableHelper.showLoadingIndicator();
                entitDto.id = salesNotes.id;
                this._salesNotesServiceProxy.convertDraftToSalesNotes(entitDto).subscribe(() => {
                    this.getSalesNotes({});
                    this.notify.success(this.l('SuccessfullyApproved'));
                    this.primengTableHelper.hideLoadingIndicator();
                });
            }
        });
       
    }

    resetFilters(): void {
        this.filterText = '';
        this.customerId = 0;
        this.currencyNameFilter = '';
        this.paymentTermNameFilter = '';

        this.getSalesNotes();
    }

}
